'use client'
import React, { ReactNode } from 'react';
import { usePagination, DOTS } from './usePagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSearchParams } from 'next/navigation';
import NextLink from 'next/link';
import { Box, Link } from '@chakra-ui/react';


const Pagination = ({ totalCount, currentPage, pageSize }: { totalCount: number, currentPage: number, pageSize: number }) => {

    const searchParams = useSearchParams()

    const paginationRange = usePagination({
        totalCount,
        pageSize,
        siblingCount: 1,
        currentPage
    });

    const getQueryString = (params: any = {}): string => {
        return (new URLSearchParams(params)).toString()
    }

    const getParams = () => {
        const objectParam: { [key: string]: string | number } = {}
        Array.from(searchParams.entries()).forEach(param => {
            objectParam[param[0]] = param[1]
        })
        return objectParam
    }

    const gotoPage = (page: any) => {
        return getQueryString({ ...getParams(), ...{ page } })
    }

    if (paginationRange && paginationRange.length < 2) {
        return <></>
    }

    const PaginationItem = ({ page, children, isButtonNavigation = false }: { page: number, isButtonNavigation?: boolean, children: ReactNode }) => {
        if (currentPage === page || page < 1 || page > totalCount) {
            return (
                <Box {...(!isButtonNavigation ? { color: '#cc0007' } : {})} fontWeight={'800'}>
                    {children}
                </Box>
            )
        }
        return (
            <Box
                as="span"
                role='group'
                fontFamily={"'Plus Jakarta Sans', sans-serif"}
                textDecoration={'none'}
            >
                <Link
                    prefetch
                    as={NextLink}
                    href={`?${gotoPage(page)}`}
                    fontWeight={'800'}
                    _hover={{ textDecoration: 'none' }}
                    _groupHover={{ backgroundSize: '0% 1px, 100% 1px', color: '#cc0007' }}
                    display={'inline'}
                    backgroundSize={'0% 1px, 0 1px'}
                    backgroundPosition={'100% 100%, 0 100%'}
                    backgroundRepeat={'no-repeat'}
                    transition={'all 0.4s ease'}
                    backgroundImage={'linear-gradient(currentcolor, currentcolor), linear-gradient(currentcolor, currentcolor)'}
                >
                    {children}
                </Link>
            </Box>
        )
    }


    return (
        <Box w={'full'} display={'flex'} justifyContent={'start'} gap={4} >
            {currentPage > 1 && <>
                <PaginationItem page={1} isButtonNavigation>
                    <FontAwesomeIcon icon={'angle-double-left'} />
                </PaginationItem>
                <PaginationItem page={currentPage - 1} isButtonNavigation>
                    <FontAwesomeIcon icon={'angle-left'} /><Box as='span' ms={4}>Anterior</Box>
                </PaginationItem>
            </>}
            {paginationRange?.map((pageNumber, i) => {
                if (pageNumber === DOTS) {
                    return (
                        <Box key={`pagination${i}`} className="shadow" >
                            &#8230;
                        </Box>
                    )
                }
                return (
                    <PaginationItem key={`pagination${i}`} page={+pageNumber}>
                        {pageNumber}
                    </PaginationItem>
                );
            })}
            {currentPage < totalCount && <>
                <PaginationItem page={currentPage + 1} isButtonNavigation>
                    <Box as='span' me={4}>Próximo</Box><FontAwesomeIcon icon={'angle-right'} />
                </PaginationItem>

                <PaginationItem page={totalCount} isButtonNavigation>
                    <FontAwesomeIcon icon={'angle-double-right'} />
                </PaginationItem>
            </>}
        </Box>
    );
};

export default Pagination;
